/**
 * SF-T-266: the message boxes' send key, as T3 Code's: Enter sends and Shift+Enter is a new line, on a keyboard.
 * Ctrl/⌘+Enter sends too. On a touch screen Enter is a new line (the button sends), and Enter that finishes an IME
 * composition (Japanese, Chinese input) never sends.
 */
export function isSendKey(e: { key: string; shiftKey: boolean; ctrlKey: boolean; metaKey: boolean; nativeEvent?: { isComposing?: boolean } }, touch = isTouchScreen()): boolean {
  if (e.key !== 'Enter' || e.nativeEvent?.isComposing) return false;
  if (e.ctrlKey || e.metaKey) return true;
  return !e.shiftKey && !touch;
}

/** A phone or tablet, whose keyboard's Enter is for new lines. */
function isTouchScreen(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
}

/** What the send button's hint says the key is. */
export const SEND_KEY_HINT = 'Enter; Shift+Enter for a new line';
